import { render, staticRenderFns } from "./ProgramModuleUpdate.vue?vue&type=template&id=2607e918&scoped=true"
import script from "./ProgramModuleUpdate.vue?vue&type=script&lang=js"
export * from "./ProgramModuleUpdate.vue?vue&type=script&lang=js"
import style0 from "./ProgramModuleUpdate.vue?vue&type=style&index=0&id=2607e918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607e918",
  null
  
)

export default component.exports